import apiClient from '@/services/axios'
import config from '@/configs'

// [STATISTICS APIs FUNCTIONS]

// count the number all basic data models
export async function fetchStatistics() {
  return apiClient
    .get(`${config.api.admin.statistics}/all`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[ADMIN/Statistics API]:', err))
}

// [CONTRACTORS APIs FUNCTIONS]

// fetch all system contractors
// get contractors by query
export async function fetchContractors(query) {
  return apiClient
    .post(`${config.api.admin.contractors}/query`, query)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[ADMIN/Contractors API]:', err))
}

// get a contractor by id
export async function fetchContractor(id) {
  return apiClient
    .get(`${config.api.admin.contractors}/${id}`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[ADMIN/Contractors API]:', err))
}

// create a new contractor
export async function createContractor(contractor) {
  return apiClient
    .post(config.api.admin.contractors, contractor)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[ADMIN/Contractors API]:', err))
}

// update a contractor
export async function updateContractor(contractor) {
  return apiClient
    .put(config.api.admin.contractors, contractor)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[ADMIN/Contractors API]:', err))
}

// [USERS APIs FUNCTIONS]

// get users by query
export async function fetchUsers(query) {
  return apiClient
    .post(`${config.api.admin.users}/query`, query)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[ADMIN/Users API]:', err))
}

// get user by id
export async function fetchUserById(id) {
  return apiClient
    .get(`${config.api.admin.users}/${id}`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[ADMIN/Users API]:', err))
}

// update user
export async function updateUser(user) {
  return apiClient
    .put(config.api.admin.users, user)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[ADMIN/Users API]:', err))
}
